<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
        <path
            d="M12 10.586l4.596-4.596a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707L13.414 12l4.596 4.596a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0L12 13.414 7.404 18.01a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707L10.586 12 5.99 7.404a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0L12 10.586z"
        />
    </svg>
</template>
